export default __webpack_public_path__ + "static/media/moment-expand.2c80ca4c.svg";